import React, { useEffect, useState } from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { RadioButtonUncheckedOutlined, RadioButtonCheckedOutlined } from '@mui/icons-material';

interface S3BucketAccountFormProps {
  connectionDetails: string;
  refreshRequired: boolean;
  handleUpdateNewGameData: any;
  onValidityChange?: (isValid: boolean) => void;
  disabled?: boolean;
}

// const S3_BUCKET_PATH_REGEX = /^s3:\/\/[^/]+\//;
// const IAP_FILE_NAME_REGEX =
//   /^[A-Za-z0-9]+_IAP_\d{4}_\d{2}_\d{2}_\d{2}_\d{2}\.csv$/;
// const IAA_FILE_NAME_REGEX =
//   /^[A-Za-z0-9]+_IAA_\d{4}_\d{2}_\d{2}_\d{2}_\d{2}\.csv$/;
// const UA_FILE_NAME_REGEX = /^[A-Za-z0-9]+_UA\.csv$/;

const S3BucketAccountForm: React.FC<S3BucketAccountFormProps> = ({
  connectionDetails,
  refreshRequired,
  handleUpdateNewGameData,
  onValidityChange,
  disabled = false,
}) => {
  const fieldValues = JSON.parse(connectionDetails || '{}');
  const [isTouched, setIsTouched] = useState({
    iapTransactionsTableName: false,
    iapFileName: false,
    iaaFileName: false,
    uaFileName: false,
  });

  useEffect(() => {
    const isPathValid = !!fieldValues.iapTransactionsTableName;
    const isIAPValid = !!fieldValues.iapFileName;
    const isIAAValid = !!fieldValues.iaaFileName;
    const isUAValid = !!fieldValues.uaFileName;

    const isAllValid = isPathValid && isIAPValid && isIAAValid && isUAValid;
    onValidityChange?.(isAllValid);
  }, [
    fieldValues.iapTransactionsTableName,
    fieldValues.iapFileName,
    fieldValues.iaaFileName,
    fieldValues.uaFileName,
  ]);

  return (
    <>
      <TextField
        label="S3 Bucket Path"
        placeholder="e.g. s3://your-bucket-name/folder/"
        sx={{
          width: '100%',
        }}
        value={fieldValues.iapTransactionsTableName}
        error={!fieldValues.iapTransactionsTableName && isTouched.iapTransactionsTableName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iapTransactionsTableName: true,
          }));
        }}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              iapTransactionsTableName: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <TextField
        label="IAP File Name"
        placeholder="e.g. mygame_IAP_2025_02_01_10_30.csv"
        sx={{
          width: '100%',
        }}
        value={fieldValues.iapFileName}
        error={!fieldValues.iapFileName && isTouched.iapFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iapFileName: true,
          }));
        }}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              iapFileName: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <TextField
        label="IAA File Name"
        placeholder="e.g. mygame_IAA_2025_02_01_10_30.csv"
        sx={{
          width: '100%',
        }}
        value={fieldValues.iaaFileName}
        error={!fieldValues.iaaFileName && isTouched.iaaFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iaaFileName: true,
          }));
        }}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              iaaFileName: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <TextField
        label="UA File Name"
        placeholder="e.g. mygame_UA.csv"
        sx={{
          width: '100%',
        }}
        value={fieldValues.uaFileName}
        error={!fieldValues.uaFileName && isTouched.uaFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            uaFileName: true,
          }));
        }}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              uaFileName: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography fontSize="0.85rem" fontWeight={700} sx={{ color: '#162936' }}>
          Monthly Refresh
        </Typography>
        <Box sx={{ display: 'flex', gap: '1rem' }}>
          {['Yes', 'No'].map((label, i) => {
            const value = i === 0;
            return (
              <FormControlLabel
                key={label}
                sx={{
                  width: 'fit-content',
                  borderRadius: '0.5rem',
                  mx: 0,
                  '& .MuiFormControlLabel-label': {
                    fontFamily: 'Manrope, sans-serif',
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: '#162936',
                  },
                }}
                label={label}
                control={
                  <Checkbox
                    checked={refreshRequired === value}
                    onChange={() => handleUpdateNewGameData('refreshRequired', value)}
                    icon={<RadioButtonUncheckedOutlined />}
                    checkedIcon={<RadioButtonCheckedOutlined />}
                    disabled={disabled}
                  />
                }
              />
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default S3BucketAccountForm;
